<template>
  <div class="p-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Car category list</h4>
          </div>
          <div class="col-6 text-right">
            <modalCarCategoryNew> </modalCarCategoryNew>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="1">Active</option>
              <option value="0">In-active</option>
            </select>
          </div>

          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm tableCarsList">
          <table
            class="v-datatable-light table table-bordered table-hover table-striped table-center"
          >
            <thead>
              <tr>
                <th class="header-item header-column-c">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-c">
                  <a
                    href="#"
                    @click.prevent="fnChangeSort('mainCarDescription')"
                    >Name</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' &&
                      sort_field == 'mainCarDescription'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' &&
                      sort_field == 'mainCarDescription'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-c">Description</th>
                <th class="header-item header-column-c">Created</th>
                <th class="header-item header-column-c">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>

                <th class="header-item header-column-c">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getCarCategoryPaginateData.data">
                <tr :key="(row, index)">
                  <td class="column-1">{{ row.id }}</td>
                  <td class="column-2">{{ row.name }}</td>

                  <td class="column-3">{{ row.description }}</td>
                  <td class="column-r">
                    {{ row.created_at }}
                  </td>
                  <td class="column-c">
                    <div v-if="row.status == 0">
                      <span class="badge bdg-in-active">In-active</span>
                    </div>
                    <div v-if="row.status == 1">
                      <span class="badge bdg-active">Active</span>
                    </div>
                  </td>

                  <td class="column-c">
                    <modalCarCategoryEdit
                      :propsData="row"
                    ></modalCarCategoryEdit>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="12">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getCarCategoryPaginateData"
                        @pagination-change-page="fnGetList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from 'laravel-vue-pagination'
import modalCarCategoryNew from '../../../components/cars/ModalCarCategoryNew.vue'
import modalCarCategoryEdit from '../../../components/cars/ModalCarCategoryEdit.vue'

export default {
  name: 'adminCarCategoryList',
  components: {
    pagination,
    modalCarCategoryNew,
    modalCarCategoryEdit
  },
  data() {
    return {
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id',
      quoteCalculation: {},
      paginate: {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters(['getCarCategoryPaginateData'])
  },
  methods: {
    ...mapActions(['fetchCarCategoryPaginate']),

    fnGetList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchCarCategoryPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchCarCategoryPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchCarCategoryPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchCarCategoryPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchCarCategoryPaginate(objNew)
    }
  },

  mounted() {
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    this.fetchCarCategoryPaginate(objNew)
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>